import { helper } from '@ember/component/helper';

import { toArray } from 'rise-ui/utils/array.js';

export default helper(function itemsWithResultHelper([ items ]) {
  return toArray(items).filter(item => item.temporalStartDate);
});
